import React, { useMemo, useCallback } from "react";
import { useApolloClient } from "@apollo/client";
import { AgGrid, AgGridReact, Grid } from "@jsq/ds/core";
import { columnDefinitions } from "./columnDefinitions";
import { PayablesGraphqlDataSource } from "./payablesGQLDataSource";
import { tableContainer } from "./styles_vanilla.css";
import { PayableRowItem } from "./types";

const rowCountPerPage = 20;

const gridOptions: AgGridReact.AgGridReactProps["gridOptions"] = {
  enableCellTextSelection: true,
  pagination: true,
  paginationPageSize: rowCountPerPage,
  paginationPageSizeSelector: false,
  suppressCellFocus: true,
  suppressContextMenu: true,
};

const defaultColumnOptions = {
  editable: false,
  flex: 1,
  minWidth: 100,
  sortable: false,
};

export const PayablesTable: React.FC = () => {
  const client = useApolloClient();

  const gridDataSource = useMemo<AgGrid.IServerSideDatasource>(() => {
    return new PayablesGraphqlDataSource(client, rowCountPerPage);
  }, [client]);

  const onRowClicked = useCallback((event: AgGrid.RowClickedEvent<PayableRowItem>) => {
    const payableRowDetails = event.data;
    if (payableRowDetails) {
      // TODO: Open payable details modal when implemented
      // For now, just store the ID for future use
      void payableRowDetails.id;
    }
  }, []);

  return (
    <Grid<PayableRowItem>
      className={tableContainer}
      cacheBlockSize={rowCountPerPage}
      columnDefs={columnDefinitions}
      defaultColDef={defaultColumnOptions}
      gridId="payables_table"
      gridOptions={{
        ...gridOptions,
      }}
      onRowClicked={onRowClicked}
      reactiveCustomComponents
      rowModelType="serverSide"
      serverSideDatasource={gridDataSource}
    />
  );
};

export default PayablesTable;
